import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'

export class CardDevelopmentCardBack extends BaseCardData {
    cardEnum = CardEnum.DevelopmentBack
    cardTypeEnum = CardTypeEnum.Development
    isCardBack = true
    tipTitle: TranslationObject = {key: 'strings:game.cards.development.back.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.development.back.body'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardKnight extends BaseCardData {
    cardEnum = CardEnum.Knight
    cardTypeEnum = CardTypeEnum.Development
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.development.knight.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.development.knight.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.development.knight.popupBody'}
    allowableTurnStates = [TurnState.Turn, TurnState.Dice]
}

export class CardVictoryPoint extends BaseCardData {
    cardEnum = CardEnum.VictoryPoint
    cardTypeEnum = CardTypeEnum.Development
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.development.victoryPoint.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.development.victoryPoint.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.development.victoryPoint.popupBody'}
    allowableTurnStates = undefined
}

export class CardMonopoly extends BaseCardData {
    cardEnum = CardEnum.Monopoly
    cardTypeEnum = CardTypeEnum.Development
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.development.monopoly.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.development.monopoly.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.development.monopoly.popupBody'}
    allowableTurnStates = [TurnState.Turn, TurnState.Dice]
}

export class CardRoadBuilding extends BaseCardData {
    cardEnum = CardEnum.RoadBuilding
    cardTypeEnum = CardTypeEnum.Development
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.development.roadBuilding.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.development.roadBuilding.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.development.roadBuilding.popupBody'}
    allowableTurnStates = [TurnState.Turn, TurnState.Dice]
}

export class CardYearOfPlenty extends BaseCardData {
    cardEnum = CardEnum.YearOfPlenty
    cardTypeEnum = CardTypeEnum.Development
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.development.yearOfPlenty.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.development.yearOfPlenty.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.development.yearOfPlenty.popupBody'}
    allowableTurnStates = [TurnState.Turn, TurnState.Dice]
}
